import React, { useContext } from 'react';
import { AnalyticsContext } from 'src/lib/AnalyticsContext';
import { Button, Grid, Grid2, GridItem, Typography } from '@riac/design-system';
import { HeadContext } from 'src/lib/HeadContext';


export const Page404 = (): JSX.Element => {
  const head = useContext(HeadContext);
  const { sendHotjarEvent } = useContext(AnalyticsContext);

  head.is404Error = true;

  React.useEffect(() => {
    if(HOTJAR_SITE_ID) {
      sendHotjarEvent('404_page_reached');
    }
  }, []);

  return head.isHead != true
    ? (
      <Grid2>
        <div className='h-[75vh] w-full flex items-center justify-center'>
          <div className='flex flex-col gap-6 max-w-prose'>
            <Typography weight='bold' color='primary'>Something went wrong</Typography>
            <Typography display size='lg'>We're sorry - we can't find the page you're looking for.</Typography>
            <div className='flex flex-col items-start gap-10'>
              <Typography size='lg' className='text-text-light'>The page may have been moved, removed, or the link you followed is outdated. Please return to the home page to continue browsing.</Typography>
              <Button to='/'>Return Home</Button>
            </div>
          </div>
        </div>
      </Grid2>
    )
    : <></>;
};
